import { useDiaryByIdQuery } from "@/features/diaries/api";
import { interfaceComponents as ic } from "@/features/patients/features/interface/components";
import { useProfileQuery } from "@/features/profile/api/selectProfile";
import { hooks as h } from "@/hooks";
import type { ActionDefinitionT } from "@/types/database/actions";
import type { StatefulDiaryT } from "@/types/database/diaries";
import type { ExtendedProfileT } from "@/types/database/profiles";
import { createFileRoute } from "@tanstack/react-router";

const Action = () => {
	const { diaryId, actionId } = Route.useParams();
	const { data: profile } = useProfileQuery();
	const { data: diary } = useDiaryByIdQuery(diaryId);
	const { action } = Route.useSearch();

	h.useNav([
		{ label: "Patients", route: { to: "/patients" } },
		{
			label: diary?.diary_name ?? "Diary",
			route: { to: "/patients/$diaryId", params: { diaryId: diaryId } },
		},
		{
			label: action?.action_name ?? "Action",
			route: {
				to: "/patients/$diaryId/action/$actionId",
				params: { diaryId: diaryId, actionId: actionId },
			},
		},
	]);

	return (
		<ic.ActionEmail
			profile={profile as ExtendedProfileT}
			diary={diary as StatefulDiaryT}
			action={action}
			actionId={actionId}
		/>
	);
};

type ActionSchema = {
	action: ActionDefinitionT;
};

export const Route = createFileRoute(
	"/_app/patients/$diaryId/action/$actionId",
)({
	validateSearch: (search: Record<string, unknown>): ActionSchema => {
		// validate and parse the search params into a typed state
		return {
			action: search.action as ActionDefinitionT,
		};
	},
	component: Action,
});
